import { Card, Button, Tooltip } from 'antd'
import TableHasPagenation from '../../../components/TableHasPagenation'
import AuthComponent from '../../../components/AuthComponent'
import useBillTypeContext from '../hooks/useStockBillTypeContext'
import { inventoryTypeMap, typeMap, statusMap, wayTypeMap } from '../config'
import moment from 'moment'

export default function BillBasicTable({
  // type = inventoryTypeEnum.IN,
  getList = () => {},
  getDetail = () => {},
  pageData = {},
  rowSelection = {},
  loading
}) {
  const { type, baseQueryModule } = useBillTypeContext()
  const typeText = inventoryTypeMap[type]
  const columns = [
    {
      title: '序号',
      dataIndex: 'no',
      render: (text, re, index) =>
        (pageData.pageIndex - 1) * pageData.pageSize + index + 1
    },
    {
      title: typeText + '单据',
      dataIndex: 'no'
    },
    {
      title: typeText + '类型',
      dataIndex: 'type',
      render: text => typeMap[text].name
    },
    {
      title: typeText + '方式',
      dataIndex: 'wayType',
      render: text => wayTypeMap[text]
    },
    {
      title: '所属供应商',
      dataIndex: 'supplierName',
      render: text => (text ? text : '--')
    },
    {
      title: '数量',
      dataIndex: 'stock'
    },
    {
      title: '单据状态',
      dataIndex: 'status',
      render: text => statusMap[text]
    },
    {
      title: '经手人',
      dataIndex: 'operName'
    },
    {
      title: typeText + '时间',
      dataIndex: 'createTime',
      render: val => moment(val).format('YYYY-MM-DD HH:mm:SS')
    },
    {
      title: '备注',
      dataIndex: 'note',
      ellipsis: { showTitle: false }
    },
    {
      title: '操作',
      dataIndex: 'id',
      render: (text, record, index) => (
        <AuthComponent authKey={baseQueryModule.baseQueryPath + 'detail/{no}'}>
          <Button type='link' onClick={() => getDetail(text, record, index)}>
            {typeText}详情
          </Button>
        </AuthComponent>
      )
    }
  ]
  return (
    <Card>
      <TableHasPagenation
        rowSelection={rowSelection}
        columns={columns}
        loading={loading}
        onPageSizeChange={getList}
        pageData={pageData}
        rowKey='no'
      />
    </Card>
  )
}
